module.exports = __webpack_public_path__ + "img/jd-loc.03581a2d.svg";